// @flow
import React from 'react';
import LoadingWheel from '@justpark/ui/src/components/LoadingWheel';
import styles from '../../../static/scss/components/listingDetails/loadingState.module.scss';

const LoadingState = () => (
  <div>
    <div className={styles.map} />
    <div className={styles.loadingWheel}>
      <LoadingWheel size="medium" />
    </div>
  </div>
);

export default LoadingState;
